import type { GameSave } from "../types/save";

export interface BootConfiguration {
  readonly initialScene: "BootScene";
  readonly hasCrossedOnboardingBoundary: boolean;
}

export function createBootConfiguration(save: GameSave): BootConfiguration {
  const hasCrossedOnboardingBoundary = save.progression.noteUnlocked === true;

  return {
    initialScene: "BootScene",
    hasCrossedOnboardingBoundary,
  };
}
